import React, { forwardRef, useState, useRef } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import classes from "../../Styles/common.module.css";
import "../../Styles/TimePicker.css"; 

const TimeRangePicker = (props) => {
  const { value = [null, null], onChange } = props;
  const [startTime, endTime] = value;

  const [selectStep, setSelectStep] = useState("start");
  const datePickerRef = useRef(null);
  const handleTimeSelect = (time) => {
    if (selectStep === "start") {
      onChange([time, endTime]);
      setSelectStep("end");

      setTimeout(() => {
        if (datePickerRef.current) {
          datePickerRef.current.setOpen(true);
        }
      }, 0);
    } else {
      onChange([startTime, time]);
      setSelectStep("start");
    }
  };

  const formatTime = (date) =>
    date
      ? `${date.getHours().toString().padStart(2, "0")}:${date
          .getMinutes()
          .toString()
          .padStart(2, "0")}`
      : "";

  const inputValue =
    startTime && endTime
      ? `${formatTime(startTime)} - ${formatTime(endTime)}`
      : startTime
      ? `${formatTime(startTime)}`
      : "";

  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <input
      ref={ref}
      onClick={onClick}
      value={inputValue}
      placeholder="Select time range"
      className={`time-picker-input ${props.className || "form-control"}`}
      style={{
        backgroundColor: props.disabled ? "#e9ecef" : undefined,
        color: props.disabled ? "#212529" : undefined,
        cursor: props.disabled ? "not-allowed" : "pointer",
      }}
      disabled={props.disabled}
    />
  ));

  return (
    <div className={`form-group ${props.label ? classes.modalGroup : ""}`}>
      {props.label && (
        <label className={classes.colFormLabel} htmlFor={props.id}>
          {props.label}
        </label>
      )}

      <div className={classes.modalPopupItem}>
        <DatePicker
          ref={datePickerRef}
          selected={selectStep === "start" ? startTime : endTime}
          onChange={handleTimeSelect}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeFormat="HH:mm"
          dateFormat="HH:mm"
          timeCaption={selectStep === "start" ? "Start Time" : "End Time"}
          customInput={<CustomInput />}
          disabled={props.disabled}
        />

        {props.errorMessage && (
          <div className={classes.invalidMessage}>{props.errorMessage}</div>
        )}
      </div>
    </div>
  );
};

export default TimeRangePicker;
